import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { QuizSubSubmitData } from './quizService';

import { QuizKey } from './keys';
import { QuizService } from './quizService';

export function useSubSubmitQuiz(quizId: string, attemptId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (data: QuizSubSubmitData) => {
      const { n, timers } = data;
      return QuizService.subSubmitQuiz(quizId, attemptId, { n, timers }).then((response) => response.data);
    },
    onSuccess: (data) => {
      if (data.id !== attemptId || !data.body.answers) return;
      queryClient.setQueryData([QuizKey.QUIZ_ATTEMPT, quizId, attemptId], data);
    },
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: [QuizKey.QUIZ_ATTEMPT, quizId, attemptId],
      });
      queryClient.invalidateQueries({ queryKey: [QuizKey.QUIZ, quizId] });
    },
  });
}
